// Centralized admin email for route gating and menu visibility.
export const ADMIN_EMAIL = 'giuggioli@gmail.com';
